import HowToBlockNew from './views/HowToBlockNew.c';
export default HowToBlockNew;
